export default {
  illustration: {
    title: 'Seu negócio na palma de sua mão.',
  },
  header: {
    title: 'Começar agora.',
    subTitle: 'Preencha o formuário ou faça o login social abaixo.',
  },
  form: {
    email: 'E-mail',
    password: 'Senha',
    register: 'Ainda não é cadastrado?'
  },
  actions: {
    google: 'Google',
    facebook: 'Facebook',
    login: 'Entrar',
    register: 'Clique aqui',
  },
  noty: {
    emailOrPasswordInvalid: 'E-mail e/ou Senha inválido(s)',
    errorLogin: 'Erro no Login! Tente novamente.'
  }
};